import TYPES from "config/store/types.ts";
import { Dispatch } from "redux";
import dayjs from "dayjs";
import { EventType } from "globals/types/models.ts";
import { tryAsyncFunc } from "globals/functions/async.ts";
import ajax from "config/ajax.ts";

import { MapBoundsType } from "globals/types/globals.ts";

// Define a type for the slice state
interface State {
  userLocation: {
    lat: number
    lng: number
  } | null
  selectedDay: string
  selectedCategoryId: number | null,
  eventById: { [key: number]: EventType }
  searchEventIds: number []
  featuredEventIds: number []

  mapBounds: MapBoundsType,

  selectedEvent: EventType | null

}

// Define the initial state using that type
const initialState: State = {
  userLocation: null,
  selectedCategoryId: null,
  selectedDay: dayjs().format("YYYY-MM-DD"),
  eventById: {},
  searchEventIds: [],
  featuredEventIds: [],

  mapBounds: {
    northLat: null,
    eastLng: null,
    southLat: null,
    westLng: null
  },
  selectedEvent: null
};

export const searchReducer = (state = initialState, action: { payload: any, type: keyof typeof TYPES }): State => {
  switch (action.type) {
    case TYPES.SET_LOCATION:
      return {
        ...state,
        userLocation: action.payload
      };
    case TYPES.SET_SELECTED_DAY:
      return {
        ...state,
        selectedDay: action.payload
      };
    case TYPES.SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategoryId: action.payload
      };
    case TYPES.GET_FEATURED_EVENTS:
      // eslint-disable-next-line no-var
      var newEventById: { [key: number]: EventType } = { ...state.eventById };
      for (const event of action.payload.events) {
        newEventById[event.id] = event;
      }
      return {
        ...state,
        eventById: newEventById,
        featuredEventIds: action.payload.events.map((event: EventType) => event.id)
      };
    case TYPES.GET_SEARCH_EVENTS:
      // eslint-disable-next-line no-var
      var newEventById: { [key: number]: EventType } = { ...state.eventById };
      for (const event of action.payload.events) {
        newEventById[event.id] = event;
      }
      return {
        ...state,
        eventById: newEventById,
        searchEventIds: action.payload.eventIds
      };
    case TYPES.GET_EVENT_BY_HANDLE_OR_UUID:
      // eslint-disable-next-line no-var
      var newEventById: { [key: number]: EventType } = { ...state.eventById };
      newEventById[action.payload.id] = action.payload;
      return {
        ...state,
        eventById: newEventById
      };
    case TYPES.SET_MAP_BOUNDS:
      return {
        ...state,
        mapBounds: action.payload
      };
    case TYPES.SET_SELECTED_EVENT:
      return {
        ...state,
        selectedEvent: action.payload
      };
    default:
      return state;
  }
};


export const searchActions = {
  setLocation: (location: { lat: number, lng: number }) => async (dispatch: Dispatch) => {
    dispatch({
      type: TYPES.SET_LOCATION,
      payload: location
    });
  },
  setMapBounds: (bounds: MapBoundsType) => async (dispatch: Dispatch) => {
    dispatch({
      type: TYPES.SET_MAP_BOUNDS,
      payload: bounds
    });
  },
  setSelectedDay: (day: string) => async (dispatch: Dispatch) => {
    dispatch({
      type: TYPES.SET_SELECTED_DAY,
      payload: day
    });
  },
  setSelectedCategory: (categoryId: number | null) => async (dispatch: Dispatch) => {
    dispatch({
      type: TYPES.SET_SELECTED_CATEGORY,
      payload: categoryId
    });
  },
  setSelectedEvent: (event: EventType | null) => async (dispatch: Dispatch) => {
    dispatch({
      type: TYPES.SET_SELECTED_EVENT,
      payload: event
    });
  },
  getPublicEventByHandleOrUuid: (value: string) => async (dispatch: Dispatch) => {
    const [res, err] = await tryAsyncFunc(ajax.get(`/public/events/handle-or-uuid/${value}`));

    if (err) {
      if (window.Sentry) {
        window.Sentry.captureException(err);
      }
      throw err;
    }


    dispatch({
      type: TYPES.GET_EVENT_BY_HANDLE_OR_UUID,
      payload: res.data.event
    });
    return res.data.event;
  },
  signalEventByUuid: (uuid: string) => async (dispatch: Dispatch) => {
    const [_, err] = await tryAsyncFunc(ajax.post(`/public/events/${uuid}/signal`));

    if (err) {
      if (window.Sentry) {
        window.Sentry.captureException(err);
      }
      throw err;
    }
  },
  featuredEvents: () => async (dispatch: Dispatch) => {
    const [res, err] = await tryAsyncFunc(ajax.get("/public/events/featured"));

    if (err) {
      if (window.Sentry) {
        window.Sentry.captureException(err);
      }
      throw err;
    }


    dispatch({
      type: TYPES.GET_FEATURED_EVENTS,
      payload: {
        events: res.data.events
      }
    });
  },
  searchEvents: () => async (dispatch: Dispatch, getState: any) => {
    const searchState: State = getState().search;

    const [res, err] = await tryAsyncFunc(ajax.post("/public/events/search", {
      mapBounds: searchState.mapBounds,
      categoryId: searchState.selectedCategoryId,
      selectedDay: searchState.selectedDay,
      excludeIds: Object.keys(searchState.eventById)//get all ids that we have
    }));

    if (err) {
      if (window.Sentry) {
        window.Sentry.captureException(err);
      }
      throw err;
    }


    dispatch({
      type: TYPES.GET_SEARCH_EVENTS,
      payload: {
        events: res.data.events,
        eventIds: res.data.eventIds
      }
    });
  }
};
